(function () {
  class BlogListingSection {
    constructor(sectionEl) {
      this.sectionEl = sectionEl;
      this.sectionId = sectionEl.dataset.sectionId;
      this.container = sectionEl.querySelector("[data-article-container]");
      this.loadMoreBtn = sectionEl.querySelector("[data-load-more]");
      this.paginationType = sectionEl.dataset.paginationType || "paginate";
      this.totalPages =
        this.container && this.container.dataset.totalPages
          ? Number(this.container.dataset.totalPages)
          : 1;
      this.currentPage = 1;
      this.infiniteObserver = null;
      this.loading = false;
    }

    init() {
      if (this.paginationType === "paginate" || !this.container || this.totalPages <= 1) return;
      if (!this.loadMoreBtn) return;

      this.loadMoreBtn.addEventListener("click", this.loadMore);

      if (this.paginationType === "infinite") {
        this.infiniteObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio >= 1) this.loadMore();
            });
          },
          { threshold: 1 }
        );
        this.infiniteObserver.observe(this.loadMoreBtn);
      }
    }

    loadMore = () => {
      if (this.loading) return;
      const nextPage = this.currentPage + 1;
      if (nextPage > this.totalPages) return;

      this.loading = true;
      this.toggleLoading(true);
      fetchSection(this.sectionId, { fromCache: true, params: { page: nextPage } })
        .then((sectionDom) => {
          const newItems = sectionDom.querySelectorAll(
            "[data-article-container] .m-blog__article-item"
          );
          newItems.forEach((node) => this.container.appendChild(node));
        })
        .catch((err) => console.error("Failed to load more articles.", err))
        .finally(() => {
          this.loading = false;
          this.toggleLoading(false);
          this.currentPage = nextPage;
          if (nextPage >= this.totalPages) {
            const paginationWrap = this.loadMoreBtn && this.loadMoreBtn.closest(".m-blog__pagination");
            if (paginationWrap) paginationWrap.remove();
            this.infiniteObserver && this.infiniteObserver.disconnect();
          }
        });
    };

    toggleLoading(loading) {
      if (!this.loadMoreBtn) return;
      this.loadMoreBtn.classList[loading ? "add" : "remove"]("m-spinner-loading");
    }
  }

  function initBlogListings() {
    document.querySelectorAll("[data-blog-listing]").forEach((el) => {
      new BlogListingSection(el).init();
    });
  }

  window.addEventListener("load", initBlogListings);
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", initBlogListings);
  }
})();
